const imperialToSiConversion  = {
    MPH_MPS:  { key: "MPH_MPS",     name: "MPH to m/s",     ratio: 0.44704 },
    FT_M:     { key: "FT_M",     name: "ft to m",     ratio: 0.3048 },
    IN_M:     { key: "IN_M",     name: "in to m",     ratio: 0.0254 },
};

export default imperialToSiConversion;